// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cmd-excel-import-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 64px);
  width: 100%;
  position: relative;
}
.cmd-excel-import-container .page-title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
}
.cmd-excel-import-container .iframe-container {
  flex: 1 1;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  background-color: #fff;
  position: relative;
  height: calc(100% - 90px);
}
.cmd-excel-import-container .iframe-container .iframe-wrapper {
  width: 100%;
  height: 100%;
}
.cmd-excel-import-container .iframe-container .iframe-wrapper iframe {
  border: none;
  outline: none;
  width: 100%;
  height: 100%;
}
.cmd-excel-import-container .download-info {
  margin-top: 10px;
  padding: 8px;
  background-color: var(--color-primary-soft);
  color: var(--color-text);
  border-radius: 4px;
  text-align: center;
}
.cmd-excel-import-container .download-info a {
  color: var(--color-primary);
  font-weight: 500;
  text-decoration: underline;
}
.cmd-excel-import-container .download-info a:hover {
  color: var(--color-primary-hover);
}
.cmd-excel-import-container .loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
.cmd-excel-import-container .loading-overlay .loading-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #2DACEC;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.cmd-excel-import-container .error-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  background-color: #fff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 10;
}
.cmd-excel-import-container .error-message p {
  color: #ff4d4f;
  margin-bottom: 16px;
}
.cmd-excel-import-container .error-message button {
  background-color: #2DACEC;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}
.cmd-excel-import-container .error-message button:hover {
  background-color: #1890ff;
}`, "",{"version":3,"sources":["webpack://./src/pages/WorkBook/WorkBook.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,WAAA;EACA,kBAAA;AAAF;AAEE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;AADJ;AAGI;EACE,WAAA;EACA,YAAA;AADN;AAGM;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AADR;AAME;EACE,gBAAA;EACA,YAAA;EAEA,2CAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;AALJ;AAOI;EACE,2BAAA;EACA,gBAAA;EACA,0BAAA;AALN;AAOM;EACE,iCAAA;AALR;AAUE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AARJ;AAUI;EACE,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,mBAAA;AARN;AAWI;EACE;IAAK,uBAAA;EART;EASI;IAAO,yBAAA;EANX;AACF;AASE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,yCAAA;EACA,WAAA;AAPJ;AASI;EACE,cAAA;EACA,mBAAA;AAPN;AAUI;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AARN;AAUM;EACE,yBAAA;AARR","sourcesContent":["// Sar와 동일한 스타일 적용 - 사이드바 문제 해결을 위해\n.cmd-excel-import-container {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 64px);\n  width: 100%;\n  position: relative;\n  \n  .page-title {\n    font-size: 24px;\n    font-weight: 600;\n    margin-bottom: 16px;\n  }\n  \n  .iframe-container {\n    flex: 1;\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n    overflow: hidden;\n    background-color: #fff;\n    position: relative;\n    height: calc(100% - 90px);\n    \n    .iframe-wrapper {\n      width: 100%;\n      height: 100%;\n      \n      iframe {\n        border: none;\n        outline: none;\n        width: 100%;\n        height: 100%;\n      }\n    }\n  }\n  \n  .download-info {\n    margin-top: 10px;\n    padding: 8px;\n    // 토큰화 — 라이트=sky-100 옅은 푸른 알림 박스, 다크=slate-900 위 옅은 sky 틴트.\n    background-color: var(--color-primary-soft);\n    color: var(--color-text);\n    border-radius: 4px;\n    text-align: center;\n\n    a {\n      color: var(--color-primary);\n      font-weight: 500;\n      text-decoration: underline;\n\n      &:hover {\n        color: var(--color-primary-hover);\n      }\n    }\n  }\n  \n  .loading-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(255, 255, 255, 0.8);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    z-index: 10;\n    \n    .loading-spinner {\n      border: 4px solid #f3f3f3;\n      border-top: 4px solid #2DACEC;\n      border-radius: 50%;\n      width: 40px;\n      height: 40px;\n      animation: spin 1s linear infinite;\n      margin-bottom: 16px;\n    }\n    \n    @keyframes spin {\n      0% { transform: rotate(0deg); }\n      100% { transform: rotate(360deg); }\n    }\n  }\n  \n  .error-message {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    text-align: center;\n    background-color: #fff;\n    padding: 24px;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    z-index: 10;\n    \n    p {\n      color: #ff4d4f;\n      margin-bottom: 16px;\n    }\n    \n    button {\n      background-color: #2DACEC;\n      color: white;\n      border: none;\n      padding: 8px 16px;\n      border-radius: 4px;\n      cursor: pointer;\n      \n      &:hover {\n        background-color: #1890ff;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
